import { styled } from 'parkdepot-shared/theme'

export const Label = styled('label', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 700
}))

export const InputPlaceholder = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    fontWeight: 300,
    marginBottom: '4px'
}))

export const InputContainer = styled<'input', { $error: boolean }>('input', ({ $error = false }) => ({
    height: '4.8rem',
    padding: '1.2rem 2rem',
    width: '100%',
    border: `1px solid ${$error ? '#D92D20' : '#EAECF0'} `,
    outline: 'none',
    borderRadius: '2.4rem',
    fontSize: '1.6rem',
    fontWeight: 300,
    lineHeight: '2.4rem'
}))

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '0rem 1.6rem',
    gap: '1.6rem',
    backgroundColor: $theme.colors.white
}))

export const ButtonsContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1.6rem',
    marginTop: '1rem'
}))

export const Name = styled('span', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700
}))

export const EmptyError = styled('div', () => ({
    color: '#D92D20',
    marginTop: '4px',
    fontSize: '1rem'
}))

export const RightIcon = styled('i', ({ $theme }) => ({
    fontSize: '2.4rem',
    color: $theme.colors.primary,
    cursor: 'pointer'
}))
